import React from "react";
import { IconProps } from "./IconProps";

const PhoneIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  if (size !== "20" || thickness !== "Thin") return null;

  return (
    <svg
      aria-label={ariaLabel}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.15 3.03 8.6 6.3a1 1 0 0 1-.25 1.15L6.9 8.65a11.1 11.1 0 0 0 4.45 4.45l1.2-1.45a1 1 0 0 1 1.15-.25l3.27 1.45a1 1 0 0 1 .58.98V16a1.5 1.5 0 0 1-1.5 1.5A13.55 13.55 0 0 1 2.5 3.95 1.5 1.5 0 0 1 4 2.45h2.17a1 1 0 0 1 .98.58Z"
        stroke={color}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PhoneIcon;